export const emptyStringToNull = (value) => {
  if (Array.isArray(value)) {
    return value;
  }

  if (Object.prototype.toString.call(value) === "[object Object]") {
    return Object.fromEntries(
      Object.entries(value).map(([key, entryValue]) => [
        key,
        emptyStringToNull(entryValue),
      ]),
    );
  }

  if (typeof value === "string" && value.trim() === "") {
    return null;
  }

  return value;
};
